import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import Seo, { buildBreadcrumbLd } from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import PageHero from "../components/PageHero";
import Reveal, { StaggerGroup, itemVariants } from "../components/Reveal";
import CtaSection from "../components/CtaSection";

const crumbs = [
  { label: "Startseite", to: "/" },
  { label: "Privatkunden", to: "/privatkunden" },
];

const situations = [
  "Wohnungs- oder Haushaltsauflösung",
  "Todesfall oder Nachlass",
  "Umzug in eine Pflegeeinrichtung",
  "Trennung",
  "Haushaltszusammenlegung",
  "Immobilienverkauf",
  "Mieterwechsel",
  "Räumung einzelner Räume",
];

export default function Privatkunden() {
  return (
    <div data-testid="page-privatkunden">
      <Seo
        path="/privatkunden"
        title="Privatkunden | Haushaltsauflösung & Entrümpelung Ulm, Neu-Ulm | Rümpeltaxi Altenstadt"
        description="Für Privatkunden in Ulm, Neu-Ulm, Illertissen und Umgebung: Haushaltsauflösung, Nachlass, Kellerentrümpelung und Umzug – respektvoll und zuverlässig. Rümpeltaxi, Altenstadt. Tel. 0151 70004440."
        jsonLd={buildBreadcrumbLd(crumbs)}
      />
      <Breadcrumbs items={crumbs} />
      <PageHero
        kicker="Für Privatkunden"
        title="Entlastung in einer oft herausfordernden Situation"
        lead="Ob Haushaltsauflösung, Nachlass, Umzug in eine kleinere Wohnung oder die Vorbereitung eines Immobilienverkaufs: Wir unterstützen Sie mit einer klaren und respektvollen Abwicklung."
      />

      <section className="bg-white py-16 md:py-24">
        <div className="container-page grid gap-14 lg:grid-cols-2 lg:gap-20">
          <Reveal>
            <h2 className="font-heading text-2xl font-bold text-anthracite md:text-3xl">
              In diesen Situationen sind wir für Sie da
            </h2>
            <StaggerGroup className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {situations.map((s) => (
                <motion.div key={s} variants={itemVariants} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-sm bg-yellow text-brand-black">
                    <Check className="h-4 w-4" />
                  </span>
                  <span className="text-base text-mid-gray">{s}</span>
                </motion.div>
              ))}
            </StaggerGroup>
          </Reveal>
          <Reveal delay={1}>
            <div className="rounded-sm border border-light-gray bg-light-gray p-8 md:p-10">
              <h3 className="font-heading text-xl font-bold text-anthracite">Respektvoll und diskret</h3>
              <p className="mt-4 text-base leading-relaxed text-mid-gray">
                Gerade in emotional belastenden Situationen ist uns ein ruhiger, respektvoller und
                diskreter Umgang wichtig. Persönliche Gegenstände und Dokumente sichern wir nach
                Ihren Vorgaben. Jeder Schritt wird vorab mit Ihnen abgestimmt.
              </p>
              <Link
                to="/kontakt"
                className="mt-6 inline-flex items-center gap-2 rounded-sm bg-yellow px-6 py-3.5 font-heading font-bold text-brand-black transition-colors hover:bg-yellow-dark"
                data-testid="privat-cta"
              >
                Unverbindlich anfragen <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>

      <CtaSection />
    </div>
  );
}
